import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { DropDownList } from "../Components/DropDownList";
import { useLocation } from "react-router-dom";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { ErrorNotFound } from "./ErrorNotFound";
import { useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";

function UnidadEditar() {
  const { state } = useLocation();
  const { id } = state;
  const [isLoading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [categoria, setCategoria] = useState({ Id: "", Nombre: "" });
  const { user } = useAuth();
  const [unidad, setUnidad] = useState({
    categoria: "",
    id: null,
    nombre: "",
  });
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Categoria",
    pageState: {},
  });
  // try {
  //   const { id } = state;
  //   console.log("On try")
  //   console.log(state)
  //   setId(id);
  // } catch (error) {
  //   console.log(error)
  // }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUnidad({
      ...unidad,
      [name]: value,
    });
  };
  if (isLoading) {
    instance
      .get("/unidad/getById/" + id)
      .then((res) => {
        setUnidad(res.data);
        setCategoria({ Id: unidad.categoria, Nombre: "" });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: id,
      categoria: categoria.Id,
      nombre: addEspaceCharacters(info.nombre.value),
      userId: user.id,
    };
    instance
      .put("unidad/update", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se han actualizado los datos del unidad de forma exitosa.`,
          redirect: true,
          page: "/CategoriaDetalle",
          pageState: { id: categoria.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <DropDownList
              required
              title="Categoría"
              endpoint={"/categoria/listActiveAndActual/" + unidad.categoria}
              //selectedItem={categoria}
              setSelectedItem={setCategoria}
              selected={unidad.categoria}
            />
          </Grid>
          <Grid item>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              value={unidad.nombre}
              autoFocus
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              size="medium"
              variant="contained"
              sx={{ mt: 3 }}
              color="success"
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { UnidadEditar };
